import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from './landing/pages/home-page/home-page.component';
import { ThanksPageComponent } from './landing/pages/thanks-page/thanks-page.component';
import { FaqPageComponent } from './landing/pages/faq-page/faq-page.component';
import { ContactPageComponent } from './landing/pages/contact-page/contact-page.component';
import { ViewProductPageComponent } from './landing/pages/view-product-page/view-product-page.component';
import { PurchasePageComponent } from './landing/pages/purchase-page/purchase-page.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { AnonGuard } from './shared/guards/anon.guard';
import { SidebarLayoutComponent } from './theme/layouts/sidebar-layout/sidebar-layout.component';
import { VerazPageComponent } from './landing/pages/veraz-page/veraz-page.component';
import { WaitingPaymentComponent } from './landing/pages/waiting-payment/waiting-payment.component';
import { TycPageComponent } from './landing/pages/tyc-page/tyc-page.component';
import { ChangePasswordComponent } from './clients/pages/change-password/change-password.component';
import { ForgotPasswordPageComponent } from './clients/pages/forgot-password-page/forgot-password-page.component';
import { ResetPasswordPageComponent } from './auth/pages/reset-password-page/reset-password-page.component';
import { SaleProductPageComponent } from './landing/pages/sale-product-page/sale-product-page.component';
import { SubscriptionProductPageComponent } from './landing/pages/subscription-product-page/subscription-product-page.component';
import { PurchaseThanksPageComponent } from './landing/pages/purchase-thanks-page/purchase-thanks-page.component';
import { AboutUsPageComponent } from './landing/pages/about-us-page/about-us-page.component';
import { ScheduleBookingPageComponent } from './schedule/pages/schedule-booking-page/schedule-booking-page.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomePageComponent,
  },
  {
    path: 'about-us',
    component: AboutUsPageComponent,
  },
  {
    path: 'waiting-payment',
    component: WaitingPaymentComponent,
  },
  {
    path: 'subscription-month',
    component: SubscriptionProductPageComponent,
  },
  {
    path: 'sale-product',
    component: SaleProductPageComponent,
  },
  {
    path: 'thanks',
    component: ThanksPageComponent,
  },
  {
    path: 'purchase-thanks',
    component: PurchaseThanksPageComponent,
  },
  {
    path: 'change-password/:id',
    component: ChangePasswordComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordPageComponent,
  },
  {
    path: 'veraz',
    component: VerazPageComponent,
  },
  {
    path: 'products/:id',
    component: ViewProductPageComponent,
  },
  {
    path: 'purchase',
    component: PurchasePageComponent,
  },
  {
    path: 'faqs',
    component: FaqPageComponent,
  },
  {
    path: 'contact',
    component: ContactPageComponent,
  },
  {
    path: 'tyc',
    component: TycPageComponent,
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    canActivate: [AnonGuard],
  },
  {
    path: 'auth/reset-password/:token',
    component: ResetPasswordPageComponent,
  },
  {
    path: 'agendar/:token',
    component: ScheduleBookingPageComponent,
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: '',
    component: SidebarLayoutComponent,
    children: [
      {
        path: 'clients',
        loadChildren: () =>
          import('./clients/clients.module').then((m) => m.ClientsModule),
        canActivate: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
